import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { siteConfig, footerLinks, heroQuote } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#4A5544] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo and Description */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#8B9D77] flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" fill="white" />
              </div>
              <span className="text-lg font-semibold">Life Stories Therapy</span>
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed">
              Honoring and preserving the God-given dignity, identity, and life stories of individuals living with dementia.
            </p>
            <p className="text-[#A88B4A] text-sm italic">
              Because every story still matters
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact</h3>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>{siteConfig.email}</li>
              <li>{siteConfig.location}</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-600 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2026 Life Stories Therapy. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm italic">
            "{heroQuote.text}" — {heroQuote.reference}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
